import { render, staticRenderFns } from "./DateHeader.vue?vue&type=template&id=6ce4f824&scoped=true&lang=pug"
import script from "./DateHeader.vue?vue&type=script&lang=ts"
export * from "./DateHeader.vue?vue&type=script&lang=ts"
import style0 from "./DateHeader.vue?vue&type=style&index=0&id=6ce4f824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4f824",
  null
  
)

export default component.exports